import { Component, OnInit } from '@angular/core';

import { AuthService } from 'src/app/shared/auth.service';
import { MessageService } from 'src/app/shared/services';

@Component({
  selector: 'setup-2fa',
  templateUrl: './setup-2fa.component.html',
  styleUrls: ['./setup-2fa.component.css']
})
export class Setup2faComponent implements OnInit {

  totp: string;
  isSubmitting: boolean;
  waitingForSecret: boolean;
  secretCode: string;
  QrUri: string;

  constructor(
    private _authService: AuthService,
    private _messageService: MessageService
  ) { }

  ngOnInit() {
    this.isSubmitting = false;
    this.QrUri = '';
    this.waitingForSecret = true;
    this._authService.setup2fa().subscribe(
      ({ data: mfaSecret }) => {
        this.waitingForSecret = false;
        const name = 'Fiona';
        const issuer = 'CrossBorder';
        this.QrUri = `otpauth://totp/${name}?secret=${mfaSecret.SecretCode}&issuer=${issuer}`;
      }
    );
  }

  totpChanged(event) {
    const pattern = /^[0-9]*$/;
    if (!pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/[^0-9]/g, '');
    }
    if (this.totp.length === 6) {
      this.isSubmitting = true;
      this._authService.verify2fa(this.totp).subscribe(
        () => {
          this.isSubmitting = false;
          this._messageService.displayMessage({ body: 'global.success_enable_2fa', type: 'success' });
          this._authService.logout();
        },
        () => {
          this.isSubmitting = false;
        });
    }
  }
}
